var parser = require('./grammar/dot.js');
module.exports = parser.parse;
